export default "__VITE_ASSET__FtCuoS5f__"